import { Component, OnInit } from '@angular/core';
import {finalize} from 'rxjs/operators';
import {ShoppingService} from '@app/shopping/shopping.service';
import {ActivatedRoute,  Router} from '@angular/router';
import {ShoppingPromotionModel} from '../../models/shopping-promotion.model';
import {PlaceServiceBase} from '@app/core/places.service';
import {ChainService} from '@app/chain/chain.service';
import {DomainService} from '@app/core/domain/domain.service';

@Component({
  selector: 'app-shopping-promotion-nf',
  templateUrl: './shopping-promotion-nf.component.html',
  styleUrls: ['./shopping-promotion-nf.component.scss']
})
export class ShoppingPromotionNfComponent {
  promotion: ShoppingPromotionModel;
  shoppingid: string;

  placeService: PlaceServiceBase;
  isShoppingDomain: boolean;

  constructor(
    private shoppingService: ShoppingService,
    private chainService: ChainService,
    private domainService: DomainService,
    private route: ActivatedRoute,
    private router: Router) {
    this.isShoppingDomain = domainService.isShoppingDomain();
    this.placeService = this.isShoppingDomain ? shoppingService : chainService;

    this.route.params.subscribe( params => {
      this.loadShoppingPromotion(params.promotionId);
      this.shoppingid = params.shoppingId;
    } );
  }

  loadShoppingPromotion(promotionId: string) {
    this.placeService.getPromotion(promotionId)
      .pipe(finalize(() => {
      }))
      .subscribe(promotions => {
        this.promotion = promotions;
      }, error => {
        console.log(`shopping error: ${error}`);
      });
  }

  openRegisterNf(typeNf: string ) {
    this.router.navigate(['/shopping/[shoppingId]/promotion/[promotionId]/nf/form'
      .replace('[shoppingId]', this.shoppingid)
      .replace('[promotionId]', this.promotion.id_hash)
    ]);
  }
}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/shopping-promotion-nf/shopping-promotion-nf.component.ts